import styled from 'styled-components';

export const StyledArea = styled.div`
  background: rgba(255, 197, 0, 0.12);
  border: 1px solid #ffc500;
  display: flex;
  box-shadow: 0 8px 32px rgb(196 200 204 / 48%), 0 1px 4px rgb(0 36 77 / 8%);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 16px 24px;
  max-width: 283px;
`;

export const Title = styled.p`
  ${(props) => props.theme.typography.subHeader}
  margin-bottom: 8px;
`;

export const Text = styled.p`
  ${(props) => props.theme.typography.caption}
  margin-bottom: 8px;
`;
